import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconStarFull from 'components/icons/iconStarFull';
import RatingAndReviewsWrapper from './RatingAndReviewsWrapper';
import RatingAndReviewsPlaceholder from './RatingAndReviewsPlaceholder';
const RatingAndReviews = t0 => {
  const $ = _c(15);
  const {
    href,
    loading: t1,
    numberOfReviews,
    onClick,
    rating,
    size: t2
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const size = t2 === undefined ? "xs" : t2;
  if (loading) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <RatingAndReviewsPlaceholder />;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    return t3;
  }
  if (!rating && !numberOfReviews) {
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <RatingAndReviewsWrapper><div className="text-xs text-gray-light2">No reviews yet</div></RatingAndReviewsWrapper>;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    return t3;
  }
  let t3;
  if ($[2] !== rating || $[3] !== size) {
    t3 = rating > 0 && <><span className="!mr-0"><IconStarFull className={classNames("h-[11px] w-[11px] mx-0.5 !mt-0", {
          "md:h-[14px] md:w-[14px]": size === "sm"
        })} stroke="transparent" /></span><span className={classNames("flex items-center min-h-[15px] text-xs font-bold text-gray-light1 mr-0.5 ml-1.5", {
        "text-sm font-bold mr-2 md:text-base": size === "sm"
      })}>{rating}/5</span></>;
    $[2] = rating;
    $[3] = size;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== numberOfReviews || $[6] !== size) {
    t4 = numberOfReviews > 0 && <span className={classNames("flex items-center min-h-[15px] text-xs text-gray-light1", {
      "text-xs md:text-sm": size === "sm"
    })}>({numberOfReviews}<span className="!mr-0"> review{numberOfReviews > 1 ? "s" : ""}</span>)</span>;
    $[5] = numberOfReviews;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== href || $[12] !== onClick || $[13] !== t5) {
    t6 = <RatingAndReviewsWrapper href={href} onClick={onClick}>{t5}</RatingAndReviewsWrapper>;
    $[11] = href;
    $[12] = onClick;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
RatingAndReviews.propTypes = {
  href: PropTypes.string,
  loading: PropTypes.bool,
  numberOfReviews: PropTypes.number,
  onClick: PropTypes.func,
  rating: PropTypes.number,
  size: PropTypes.oneOf(['xs', 'sm'])
};
export default RatingAndReviews;